import { Component, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { RuleInterface } from '@vendasta/automata/lib';
import { CommonTriggerPanelComponent } from '../../../common/common-trigger-panel.component';
import { TriggerBaseRules } from '../../../common/decorators/trigger-rules.decorator';
import { NoRules } from '../../common';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { TriggerService } from '../../../../trigger.service';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { AutomataContextService, ContextConfigMap } from '@galaxy/automata/shared';
import { CustomOutputParamsService } from '../../../../component-loader/custom-output-parameters/custom-output-params.service';
import { Environment, EnvironmentService } from '@galaxy/core';

const getApiUrlProd = (namespace: string, externalId: string) =>
  `https://automations.businessapp.io/start/${namespace}/${externalId}`;
const getApiUrlDemo = (namespace: string, externalId: string) =>
  `https://automata-demo.apigateway.co/start/${namespace}/${externalId}`;

@Component({
  selector: 'automata-api-trigger-no-entity-panel',
  templateUrl: './api-trigger-no-entity-panel.component.html',
  styleUrls: ['./api-trigger-no-entity-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    GalaxyPipesModule,
    ClipboardModule,
  ],
})
export class ApiTriggerNoEntityPanelComponent extends CommonTriggerPanelComponent implements OnInit {
  automationId: string = this.triggerService.automationId;
  url = '';
  public automationContext = this.automationContextService.currentContext;
  contextConfig = ContextConfigMap[this.automationContext];

  constructor(
    private readonly automationContextService: AutomataContextService,
    protected readonly triggerService: TriggerService,
    private readonly customOutputParamsService: CustomOutputParamsService,
    private readonly environmentService: EnvironmentService,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.savingEnabled$.next(true);

    if (this.environmentService.getEnvironment() === Environment.PROD) {
      this.url = getApiUrlProd(this.automation.namespace, this.automation.externalId);
    } else {
      this.url = getApiUrlDemo(this.automation.namespace, this.automation.externalId);
    }
  }

  fillRuleValues(rules: RuleInterface[]): RuleInterface[] {
    return rules;
  }

  @TriggerBaseRules
  getBaseRules(): RuleInterface[] {
    return NoRules();
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return this.customOutputParamsService.returnKeyValuesArray.controls as UntypedFormArray[];
  }

  isFormValid(): boolean {
    return true;
  }
}
